import styled from 'styled-components'

export const Wrapper = styled.div(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  gap: theme.space['10'],
}))

export const Badge = styled.div<{ $bgColor: string }>(({ $bgColor }) => ({
  alignItems: 'center',
  backgroundColor: $bgColor,
  borderRadius: '50%',
  display: 'flex',
  flexShrink: 0,
  height: '2.4rem',
  justifyContent: 'center',
  width: '2.4rem',
}))
